import React from 'react';
import { Stack } from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';
import { useMutation } from 'react-query';
import axios, { endPoints } from 'api/request';
import throttle from 'lodash/throttle';
import { useRecoilState } from 'recoil';
import Select from 'components/select';
import { OrderPayload } from 'pages/service-account-creation/store';
import ProvisioningStyles from 'pages/service-account-creation/style';
// import HelpImg from 'pages/provisioning/_components/helpImg';
import { InputInfo } from 'pages/service-account-creation/components/input-info';

const filter = createFilterOptions();
const ApplicationService = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [value, setValue] = React.useState(order?.appProfileDetails || null);
    const [ccInputValue, setCCInputValue] = React.useState('');
    const [options, setOptions] = React.useState([]);

    const bCiPostApi = useMutation((payload) => axios.post(`${endPoints.riServices.COMMON.businessCiDetails}`, payload));

    const setAppService = (ciService) => {
        setOrder({
            ...order,
            applicationServiceCI: ciService?.label,
        });
    };
    const resetOptions = () => {
        setOptions([]);
    };

    const fetch = React.useMemo(
        () =>
            throttle((inputValue) => {
                bCiPostApi?.mutate({
                    businessApplication: null,
                    applicationService: inputValue,
                });
            }, 1000),
        []
    );

    React.useEffect(() => {
        if (ccInputValue === '') {
            resetOptions();
        }
        if (ccInputValue && ccInputValue !== '' && ccInputValue?.length > 2) fetch(ccInputValue);
    }, [ccInputValue, fetch]);

    React.useEffect(() => {
        if (bCiPostApi?.isSuccess) {
            if (bCiPostApi?.data?.data?.applications) {
                const { applicationServices = [] } = bCiPostApi?.data?.data?.applications?.[0] || {};
                const combinedValue = applicationServices?.map((app) => ({
                    label: `${app.serviceName}`,
                    value: `${app.serviceName}`,
                    data: app,
                }));
                setOptions(combinedValue);
            }
        }
    }, [bCiPostApi?.isSuccess]);

    React.useEffect(() => {
        if (value !== null && value?.value) {
            setAppService(value);
        }
    }, [value]);

    React.useEffect(() => {
        return !order?.applicationServiceCI && order?.isTouched ? setIsTouched(true) : setIsTouched(false);
    }, [order?.isTouched, order?.applicationServiceCI]);

    return (
        <>
            <Stack direction="row" spacing={1} sx={ProvisioningStyles.stack}>
                <Select
                    key="applicationName"
                    label="Application Service CI *"
                    loading={bCiPostApi?.isLoading}
                    placeholder="Type to search"
                    value={order?.applicationServiceCI || null}
                    includeInputInList
                    onInputChange={(event, newInputValue) => {
                        if (newInputValue && newInputValue !== '') setCCInputValue(newInputValue);
                    }}
                    onChange={(event, newValue) => {
                        if (typeof newValue === 'string') {
                            setValue({
                                label: newValue,
                            });
                        } else if (newValue && newValue.inputValue) {
                            // Create a new value from the user input
                            setValue({
                                label: newValue.inputValue,
                            });
                        } else {
                            setValue(newValue);
                        }
                    }}
                    filterOptions={(optionValues, params) => filter(optionValues, params)}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    options={options}
                    getOptionLabel={(option) => {
                        // Value selected with enter, right from the input
                        if (typeof option === 'string') {
                            return option;
                        }
                        // Add "xxx" option created dynamically
                        if (option.inputValue) {
                            return option.inputValue;
                        }
                        // Regular option
                        return option.label;
                    }}
                    renderOption={(props, option) => (
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        <li {...props}>{option.label}</li>
                    )}
                    sx={ProvisioningStyles.costCenter}
                    freeSolo
                    isRequired={isTouched}
                />
                <InputInfo title="Type to Search Application." />
            </Stack>
        </>
    );
};

export default React.memo(ApplicationService);
